export const EDGE_REGION_HINT_HEADER = 'atl-edge-region-hint';

export function getEdgeRegionHint(
	primaryProduct: string,
	productDataRegions: Record<string, string[]>,
): string {
	const primaryProductDataRegion = primaryProduct
		? productDataRegions[primaryProduct]?.[0]
		: undefined;
	const confluenceDataRegion = productDataRegions['confluence']?.[0];
	const jiraDataRegion = productDataRegions['jira']?.[0];
	const firstDataRegion = Object.entries(productDataRegions)[0]?.[0];

	return primaryProductDataRegion ?? confluenceDataRegion ?? jiraDataRegion ?? firstDataRegion;
}
